var $6f40c3a58f594b58$exports = {};
// Завдання "Таймер інтервалу": Створіть програму, яка виводить повідомлення кожну секунду за допомогою setInterval. Після 5 повідомлень зупиніть виконання інтервалу за допомогою clearInterval.
const $6f40c3a58f594b58$var$timerBtn = document.querySelector(".timer");
let $6f40c3a58f594b58$var$count = 0;
$6f40c3a58f594b58$var$timerBtn.addEventListener("click", ()=>{
    const taimer = setInterval(()=>{
        alert("\u041F\u0440\u043E\u0439\u0448\u043B\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0430");
        $6f40c3a58f594b58$var$count += 1;
        if ($6f40c3a58f594b58$var$count === 5) {
            clearInterval(taimer);
            alert("\u0427\u0430\u0441 \u0432\u0438\u0439\u0448\u043E\u0432");
        }
    }, 1000);
});
// Завдання "Анімація елементів": Створіть кілька елементів на сторінці і реалізуйте просту анімацію, змінюючи їх розмір, положення чи стилі через певний інтервал за допомогою setInterval.
const $6f40c3a58f594b58$var$box1El = document.querySelector(".box1");
const $6f40c3a58f594b58$var$box2El = document.querySelector(".box2");
const $6f40c3a58f594b58$var$box3El = document.querySelector(".box3");
const $6f40c3a58f594b58$var$btn = document.querySelector(".btn");
$6f40c3a58f594b58$var$btn.addEventListener("click", ()=>{
    let height1 = 80;
    let width1 = 80;
    setInterval(()=>{
        width1 += 4;
        height1 += 5;
        let r = Math.round(Math.random() * 254 + 1);
        let g = Math.round(Math.random() * 254 + 1);
        let b = Math.round(Math.random() * 254 + 1);
        $6f40c3a58f594b58$var$box1El.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;
        $6f40c3a58f594b58$var$box1El.style.width = width1 + "px";
        $6f40c3a58f594b58$var$box1El.style.height = height1 + "px";
    }, 1000);
    let top1 = 300;
    let left1 = 190;
    setInterval(()=>{
        top1 += 4;
        left1 += 6;
        let r = Math.round(Math.random() * 254 + 1);
        let g = Math.round(Math.random() * 254 + 1);
        let b = Math.round(Math.random() * 254 + 1);
        $6f40c3a58f594b58$var$box2El.style.top = top1 + "px";
        $6f40c3a58f594b58$var$box2El.style.left = left1 + "px";
        $6f40c3a58f594b58$var$box2El.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;
    }, 1000);
    let left2 = 50;
    setInterval(()=>{
        left2 += 10;
        let r = Math.round(Math.random() * 254 + 1);
        let g = Math.round(Math.random() * 254 + 1);
        let b = Math.round(Math.random() * 254 + 1);
        $6f40c3a58f594b58$var$box3El.style.left = left2 + "px";
        $6f40c3a58f594b58$var$box3El.style.color = `rgb(${r}, ${g}, ${b})`;
    }, 1000);
});
// Завдання "Інтерактивна гра": Створіть просту інтерактивну гру, де гравець має натискати на елементи на сторінці протягом певного інтервалу часу, використовуючи setInterval. Реалізуйте лічильник очок та відслідковуйте кількість натисків гравця.
const $6f40c3a58f594b58$var$startEl = document.querySelector(".start");
const $6f40c3a58f594b58$var$click1El = document.querySelector(".click1");
const $6f40c3a58f594b58$var$click2El = document.querySelector(".click2");
const $6f40c3a58f594b58$var$click3El = document.querySelector(".click3");
const $6f40c3a58f594b58$var$click4El = document.querySelector(".click4");
const $6f40c3a58f594b58$var$click5El = document.querySelector(".click5");
const $6f40c3a58f594b58$var$blocksEl = document.querySelector(".blocks");
const $6f40c3a58f594b58$var$pointEl = document.querySelector(".point");
let $6f40c3a58f594b58$var$point = 0;
$6f40c3a58f594b58$var$startEl.addEventListener("click", ()=>{
    setInterval(()=>{
        let id = Math.round(Math.random() * 4 + 1);
        console.log(id);
        if (Number($6f40c3a58f594b58$var$click1El.id) === id) $6f40c3a58f594b58$var$click1El.style.backgroundColor = "green";
        else $6f40c3a58f594b58$var$click1El.style.backgroundColor = "blue";
        if (Number($6f40c3a58f594b58$var$click2El.id) === id) $6f40c3a58f594b58$var$click2El.style.backgroundColor = "green";
        else $6f40c3a58f594b58$var$click2El.style.backgroundColor = "blue";
        if (Number($6f40c3a58f594b58$var$click3El.id) === id) $6f40c3a58f594b58$var$click3El.style.backgroundColor = "green";
        else $6f40c3a58f594b58$var$click3El.style.backgroundColor = "blue";
        if (Number($6f40c3a58f594b58$var$click4El.id) === id) $6f40c3a58f594b58$var$click4El.style.backgroundColor = "green";
        else $6f40c3a58f594b58$var$click4El.style.backgroundColor = "blue";
        if (Number($6f40c3a58f594b58$var$click5El.id) === id) $6f40c3a58f594b58$var$click5El.style.backgroundColor = "green";
        else $6f40c3a58f594b58$var$click5El.style.backgroundColor = "blue";
    }, 2000);
});
$6f40c3a58f594b58$var$blocksEl.addEventListener("click", (event)=>{
    if (!event.target.matches("p")) return;
    if (event.target.style.backgroundColor === "green") {
        $6f40c3a58f594b58$var$point += 1;
        $6f40c3a58f594b58$var$pointEl.textContent = $6f40c3a58f594b58$var$point;
    }
    event.target.style.backgroundColor = "blue";
});
// Завдання "Контроль часу": Створіть програму, яка дозволяє користувачу встановити певний час (у секундах) за допомогою введення з клавіатури. Потім використовуйте setTimeout або setInterval, щоб після встановленого часу вивести повідомлення.
const $6f40c3a58f594b58$var$secondsEl = document.querySelector(".seconds");
const $6f40c3a58f594b58$var$start2Btn = document.querySelector(".start2");
$6f40c3a58f594b58$var$start2Btn.addEventListener("click", ()=>{
    const seconds = Number($6f40c3a58f594b58$var$secondsEl.value);
    if ($6f40c3a58f594b58$var$secondsEl.value === "") {
        alert("\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0447\u0438\u0441\u043B\u043E");
        return;
    }
    setTimeout(()=>{
        alert("\u0427\u0430\u0441 \u0432\u0438\u0439\u0448\u043E\u0432");
    }, seconds * 1000);
});


//# sourceMappingURL=hw-js-frontend4-10.55732eaa.js.map
